<h2 mat-dialog-title>{{ title }}</h2>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content class="campaign-dialog-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Campaign name</mat-label>
      <input matInput formControlName="name" maxlength="120" autocomplete="off" />
      <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Max users</mat-label>
      <input matInput type="number" formControlName="maxUsers" min="1" />
      <mat-hint>Default 100. Rejected signups still count toward this cap.</mat-hint>
      <mat-error *ngIf="form.get('maxUsers')?.invalid">Enter a whole number of at least 1</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Expires at (optional)</mat-label>
      <input
        matInput
        [matDatepicker]="expiresPicker"
        formControlName="expiresAt"
        [min]="minExpiresDate"
        readonly
        (click)="expiresPicker.open()" />
      <mat-datepicker-toggle matIconSuffix [for]="expiresPicker"></mat-datepicker-toggle>
      <button
        *ngIf="form.get('expiresAt')?.value"
        mat-icon-button
        matIconSuffix
        type="button"
        aria-label="Clear expiry date"
        (click)="clearExpiresAt()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker #expiresPicker></mat-datepicker>
      <mat-hint>Leave empty for no expiry. Expires at end of the selected day.</mat-hint>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit">
      {{ data.mode === 'create' ? 'Create' : 'Save' }}
    </button>
  </mat-dialog-actions>
</form>
